import script from "./STK08_021MAN.vue?vue&type=script&setup=true&lang=js"
export * from "./STK08_021MAN.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__